import React from 'react';
import { Container, Typography } from '@mui/material';
import Header from '../components/layout/Header';
import RegionsSection from '../components/sections/RegionsSection';

const SelectDep = () => {
  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, px: { xs: 2, sm: 3 } }}>
        <Typography align='center' variant="h1" component="h1" gutterBottom sx={{ fontSize: { xs: '2rem', sm: '3rem' } }}>
          Sélectionnez votre département
        </Typography>
        <Typography variant="body1" align='center' gutterBottom sx={{ fontSize: { xs: '0.9rem', sm: '1rem' }, mb: { xs: 3, sm: 4 } }}>
          Veuillez choisir votre territoire pour continuer
        </Typography>
        <RegionsSection />
      </Container>
    </>
  );
};

export default SelectDep;